window.NPS = window.NPS || {};
window.NPS.Views = window.NPS.Views || {};
window.NPS.Views.LinkEdit = window.NPS.Views.LinkEdit || {};
window.NPS.Views.LinkEdit.Views = window.NPS.Views.LinkEdit.Views || {};
window.NPS.Views.LinkEdit.Views['select/library'] = (function($, _) {

    function view(editor, opts) {
        var
            self = this,
            opts = _.defaults({}, opts)
        ;
        this.editor = editor;
        this.$el = editor.$el.find('[data-page]');
        this.link = editor.link;
        this.library = this.$el.data('library');
        this.anchors = this.$el.data('anchors') !== 'disallow';

        this.node = null;

        this.opts = opts;

        this.$selection = null;
        this.setNode(this.link.getProperty('nodeId') || 'root');
    }

    view.prototype.$ = function (sp) {
        return this.$el.find(sp);
    };

    view.prototype.stage = function () {
        var self = this;

        self.$el.on('click.npseditorlinksSelectLibrary', '.tree .node', function() {
            self.setNode($(this).data('node'));
        });
        self.$el.on('click.npseditorlinksSelectLibrary', '.objects .element', function() {
            self.setSelection({
                id: $(this).data('object'),
                reference: $(this).data('reference')
            });
        });

        self.$el.on('submit.npseditorlinksSelectLibrary', '.search form', function(e) {
            e.preventDefault();
            e.stopPropagation();

            var field = self.$('#searchField').val(),
                specificContainer = self.$("#searchValue-"+field),
                osel = specificContainer.find('select'),
                textContainer = self.$("#searchValue");

            self.setSearch({field: field, value: (osel.length) ? osel.val() : textContainer.find('input').val()})
        });

        return this;
    };
    view.prototype.unstage = function () {
        this.$el.off('.npseditorlinksSelectLibrary');
        return this;
    };

    view.prototype.setNode = function (node) {
        var self = this, $nodes = self.$('.tree').find('.node'), d;

        this.node = node;

        $nodes.removeClass('selected');
        $nodes.filter('[data-node="' + node +'"]').addClass('selected');

        d = _.extend({}, this.opts.data, {nodeId: node});
        delete d.srchref;

        return $.get(this.opts.path + 'select/library-objects.htm', d)
            .then(function(resp) {
                self.$('.objects').html(resp);
                return self;
            })
            .then(function() {
                if (self.link.getProperty('leafId')) {
                    if (self.link.getProperty('reference')) {
                        self.$('.objects').find('.element[data-object="'+self.link.getProperty('leafId')+'"][data-reference="'+self.link.getProperty('reference')+'"]').click();
                    } else {
                        self.$('.objects').find('.element[data-object="'+self.link.getProperty('leafId')+'"]').click();
                    }
                }
                return self;
            })
        ;
    };
    view.prototype.setSearch = function (search) {
        var d = _.extend({}, this.opts.data, {nodeId: this.node, sf: search.field, sv: search.value});
        delete d.srchref;

        return $.get(this.opts.path + 'select/library-objects.htm', d)
            .then(function(resp) {
                self.$('.objects').html(resp);
                return self;
            })
        ;
    };

    view.prototype.setSelection = function (info) {
        var self = this,
            $item = self.$('.objects').find('.element[data-object='+ info.id +']'),
            $anchors = self.$('#targetAnchor')
        ;

        if (info.reference) {
            $item = $item.filter('[data-reference='+ info.reference +']');
        }


        if (self.$selection) {
            self.$selection.removeClass('selected');
        }
        $item.addClass('selected');
        self.$selection = $item;


        $anchors.hide();
        if (self.anchors && self.$selection) {
            $anchors.show();

            XMLSelect(self.$('#anchorSelect'), 'load', {
                url: self.opts.path + 'documentAnchors.xml',
                data: {objectId: info.id}
            });
        }

        if ($item.data('structure') === 'yes') {
            $.get(self.opts.path + 'select/library-structure.htm', {"_": $.now(), objectId: info.id}).then(function(resp) {
                var $container = $item.closest('.element-container');
                if (!$container.find('.element-structure').length) {
                    $container.append('<div class="element-structure"></div>');
                }
                $container.find('.element-structure').html(resp)
            });
        }


        self.editor.enableNext('select/library');

        return self;
    };


    view.prototype.commit = function () {
        var self = this,
            site = this.opts.data.gsite, libraryId = this.opts.data.libraryId,
            objectId = self.$selection.data('object'),
            reference = self.$selection.data('reference') || '',
            $downsel = self.$('#downloadSelect').find(':selected'),
            $anchorsel = self.$('#anchorSelect').find(':selected')
        ;

        var aParams=[],
            displayMode = $downsel.val(),
            linker = $downsel.attr('linker'),
            anchorId = $anchorsel.val() || '';



        if (linker.match(/\[site\]/)) {
            linker = linker.replace(/\[site\]/, site);
        } else {
            aParams.push('site='+site);
        }

        if (linker.match(/\[objectId\]/)) {
            linker = linker.replace(/\[objectId\]/, objectId);
        } else {
            aParams.push('objectId='+objectId);
        }

        if (reference) {
            aParams.push('reference='+reference);
        }

        if (linker.indexOf('?')!=-1) {
            var strMoreParams = linker.substr(linker.indexOf('?')+1);
            linker = linker.substr(0, linker.indexOf('?'));

            var mParams = strMoreParams.split('&');
            for (var i=0, l = mParams.length; i<l; i++) {
                aParams.push(mParams[i]);
            }
        }

        var url = linker;
        if (aParams.length) {
            url+= '?'+aParams.join('&');
        }
        if (anchorId) {
             url+= "#"+anchorId;
        }

        self.link.setProperties({
            content: 'l',
            link: url,
            library: libraryId,
            nodeId: self.node,
            leafId: objectId,
            reference: reference,
            anchorId: anchorId,
            displayMode: $downsel.val()
        });

        return self;
    };
    return function(editor, opts) {
        return new view(editor, opts);
    }

})(window.jQuery, window._);